const MOBILE_MAX_WIDTH = 899;

export function isMobile() {
  if (typeof window === "undefined") return false;
  return window.innerWidth <= MOBILE_MAX_WIDTH;
}

export const DeviceBreakpoints = {
  MOBILE_MAX_WIDTH,
};

